import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

import { ConstraintData, ConstraintType } from './constraint-type';

export interface Constraint {
    name: string;
    type: ConstraintType;
    mode: ConstraintMode;
    module_id: string | null;
    row: number | null;
    column: number | null;
    row_range?: number | null;
    column_range?: number | null;
    slot_id: string | null;
    data: ConstraintData | null;
    update_timestamp: string;
    id: string;
    account_id: string;
    spot_id: string;
    creation_timestamp: string;
}

export interface CreateConstraint {
    name?: string;
    type?: ConstraintType;
    mode?: ConstraintMode;
    module_id?: string | null;
    row?: number | null;
    column?: number | null;
    row_range?: number | null;
    column_range?: number | null;
    slot_id?: string | null;
    data?: ConstraintData;

    // for the purpose of creating a constraint on the top level of the application
    spot_id?: string | null;
}

export interface UpdateConstraint extends CreateConstraint {
    null_fields?: string[] | null;
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    SPOT_ID = 'spot_id',
    MODULE_ID = 'module_id',
    SLOT_ID = 'slot_id',
    CONSTRAINT_TYPE = 'constraint_type',
    PRODUCT_ID = 'product_id',
    EQUIPMENT_ID = 'equipment_id'
}

export type ConstraintQueryParams = QueryParams & DefaultQueryParams;

export type ConstraintListResponse = PaginatedResponse<Constraint>;

export enum ConstraintMode {
    ONLY = 'only',
    PREFERABLY = 'preferably',
    RATHER_NOT = 'rather_not',
    DEFINITELY_NOT = 'definitely_not'
}
